import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/lib/api";
import { Section } from "@/components/intel/Section";
import { ItemCardEmpty } from "@/components/intel/ItemCard";
import { CircleCard, type DirectoryCircle } from "@/components/circles/CircleCard";

export function Circles() {
  const api = useApi();
  const list = useQuery({
    queryKey: ["circles"],
    queryFn: () => api.get<{ circles: DirectoryCircle[] }>("/circles"),
  });

  const circles = list.data?.circles ?? [];

  return (
    <div className="px-10 py-10 max-w-5xl">
      <header className="mb-12">
        <p className="label-eyebrow">Rooms</p>
        <h1 className="mt-2 text-display-2 font-display">Circles</h1>
        <p className="mt-3 text-whisper max-w-xl leading-relaxed">
          Structured transformation rooms — brotherhood, sisterhood, leadership,
          founder, athlete, faith, wellness. Quiet by default, intentional by design.
        </p>
      </header>

      <Section
        eyebrow="Directory"
        title="Active circles"
        detail="Open circles invite an immediate join; private circles route through your request."
      >
        {list.isLoading ? (
          <ItemCardEmpty label="Reading rooms…" />
        ) : circles.length === 0 ? (
          <ItemCardEmpty
            label="No active circles in your community yet."
            detail="Once your community's circles are curated, they'll appear here. This is intentional space, not absence."
          />
        ) : (
          <div className="grid gap-4">
            {circles.map((c) => (
              <CircleCard key={c.id} circle={c} />
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
